import CmsModel from '@/models/Cms';

const GET_DESTINATION_PAGING_LIST = 'GET_DESTINATION_PAGING_LIST';
const UPDATE_DESTINATION_HOT_DATA = 'UPDATE_DESTINATION_HOT_DATA';
const UPDATE_DESTINATION_SPREAD_DATA = 'UPDATE_DESTINATION_SPREAD_DATA';

/**
 * 获取目的地数据
 */
async function getDestinationPagingList(params) {
  const payload = await new CmsModel().getDestinationPagingList(params);
  return {
    type: GET_DESTINATION_PAGING_LIST,
    payload
  }
}

/**
 * 点击更新产品热度数据
 */
async function updateDestinationHotData(payload) {
  return {
    type: UPDATE_DESTINATION_HOT_DATA,
    payload
  }
}

/**
 * 更新是否折叠
 */
async function updateDestinationSpreadData(payload) {
  return {
    type: UPDATE_DESTINATION_SPREAD_DATA,
    payload
  }
}

const ACTION_TYPES = {
  GET_DESTINATION_PAGING_LIST,
  UPDATE_DESTINATION_HOT_DATA,
  UPDATE_DESTINATION_SPREAD_DATA,
};

const ACTION = {
  getDestinationPagingList,
  updateDestinationHotData,
  updateDestinationSpreadData,
};

const Destination = {
  ACTION_TYPES,
  ACTION
}

export default Destination;